
import { Component, Vue, Prop, Emit } from 'vue-property-decorator'

export interface ExamineOption {
    status: number
    target: any
}

/**
 * 
 * @prop    value       热线列表数据
 * @emit    examine     做出审核
 * 
*/
@Component({
    name: 'phone-examine-table'
})
export default class extends Vue {
    @Prop({ required: true }) value!: any[]
    private options = [
        { value: '未处理', key: 1 },
        { value: '正确', key: 2 },
        { value: '错误', key: 3 }
    ]

    @Emit('examine')
    private onStatusChange(status: number, target: any): ExamineOption {
        return { status, target }
    }
}
